import { emailRegex, passCodeRegex } from './regExp';

export const inputsLength = {
  reportedPolicyNumber: {
    max: 50,
    min: 1,
  },
  firstName: {
    max: 50,
  },
  lastName: {
    max: 50,
  },
  middleName: {
    max: 50,
  },
  businessName: {
    max: 255,
  },
  name: {
    max: 255,
  },
  representativeFirstName: {
    max: 50,
  },
  representativeLastName: {
    max: 50,
  },
  department: {
    max: 50,
  },
  producerNumber: {
    max: 50,
  },
  mobileNumber: {
    min: 14,
    max: 14,
  },
  profileMobileNumber: {
    min: 10,
    max: 10,
  },
  landline: {
    min: 14,
    max: 14,
  },
  fax: {
    min: 14,
    max: 14,
  },
  ssn: {
    min: 11,
    max: 11,
  },
  tin: {
    min: 11,
    max: 11,
  },
  suffix: {
    min: 2,
    max: 10,
  },
  address: {
    max: 50,
  },
  city: {
    max: 50,
  },
  zipCode: {
    max: 10,
  },
  allocation: {
    max: 3,
  },
  policyCompany: {
    max: 50,
  },
  reAttn: {
    max: 50,
  },
  addressDetails: {
    max: 100,
  },
  streetAddress: {
    max: 100,
  },
  state: {
    max: 50,
  },
  faceAmount: {
    max: 36,
  },
  noteTitle: {
    max: 50,
  },
  noteDescription: {
    max: 512,
  },
} as const;

export const SSN_EXTRA_LENGTH = 2;
export const TIN_EXTRA_LENGTH = 2;
export const MIN_SEARCH_VALUE = 3;
export const MAX_ALLOCATION_VALUE = 100;

export const REQUIRED_ERROR = 'Oops! Required data is empty';
export const PERSONAL_FIELD_REQUIRED_ERROR = (fieldName: string) => `${fieldName} is required`;
export const COUNTRY_CODE_ERROR = 'Only U.S. number can be entered';
export const SSN_ERROR = `Please enter at least ${inputsLength.ssn.min - SSN_EXTRA_LENGTH} characters`;
export const TIN_ERROR = `Please enter at least ${inputsLength.ssn.min - TIN_EXTRA_LENGTH} characters`;
export const EMAIL_ERROR = "Email should contain '@' symbol and domain";
export const SUFFIX_ERROR = `Please enter at least ${inputsLength.suffix.min} characters`;
export const PROFILE_MOBILE_ERROR = `Please enter at least ${inputsLength.profileMobileNumber.min} characters`;
export const MAX_PERCENT_ERROR = `Oops! You've exceeded the allowed %. Please update the value`;
export const MAX_LENGTH_ERROR = (maxLength: number) => `Input can have a maximum of ${maxLength} characters`;
export const BUSINESS_NAME_MAX_LENGTH_ERROR = `Input can have a maximum of ${inputsLength.businessName.max} characters`;
export const CONTANT_PREFERENCE_VALUE_ERROR = `Please enter at least ${inputsLength.fax.min} characters`;
export const ENTER_VALID_DATE_ERROR = `Please enter a valid date`;

export const validateEmail = (value: string | undefined) => {
  return value === undefined || value === '' || emailRegex.test(value);
};

export const validatePassCode = (character: string) => {
  return passCodeRegex.test(character);
};

export const defaultMaskReplacement = { _: /\d/ };

export const masks = {
  mobilePhone: { mask: '(___) ___-____', replacement: defaultMaskReplacement },
  fax: { mask: '(___) ___-____', replacement: defaultMaskReplacement },
  landline: { mask: '(___) ___-____', replacement: defaultMaskReplacement },
  ssn: { mask: '___-__-____', replacement: defaultMaskReplacement },
  tin: { mask: '___-__-____', replacement: defaultMaskReplacement },
  suffix: { mask: '__________', replacement: { _: /./ } },
  zipcode: { mask: '__________', replacement: defaultMaskReplacement },
};
